/**
 * Prevents Klaviyo embed forms from duplicating when SPA-style
 * section updates (facets/sort) re-trigger the Klaviyo onsite SDK.
 */

const GUARDED_ATTR = 'data-klaviyo-embed-guarded';
const guardedBlocks = new WeakSet();

/**
 * @param {Element} container
 */
function pruneDuplicateKlaviyoForms(container) {
  const forms = container.querySelectorAll('form.klaviyo-form');
  if (forms.length <= 1) return;

  for (let i = forms.length - 1; i > 0; i--) {
    const form = forms[i];
    const wrapper = form.closest('.needsclick') ?? form;
    const announcer = wrapper.nextElementSibling;

    wrapper.remove();

    if (announcer?.getAttribute('role') === 'alert') {
      announcer.remove();
    }
  }
}

/**
 * @param {Element} block
 */
function guardKlaviyoEmbed(block) {
  if (guardedBlocks.has(block)) return;

  const container = block.querySelector('[class*="klaviyo-form-"]:not(.klaviyo-form-block)');
  if (!(container instanceof HTMLElement)) return;

  guardedBlocks.add(block);
  container.setAttribute(GUARDED_ATTR, '');

  pruneDuplicateKlaviyoForms(container);

  const observer = new MutationObserver(() => {
    pruneDuplicateKlaviyoForms(container);
  });

  observer.observe(container, { childList: true, subtree: true });
}

function initKlaviyoEmbedGuard() {
  document.querySelectorAll('.klaviyo-form-block').forEach(guardKlaviyoEmbed);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initKlaviyoEmbedGuard, { once: true });
} else {
  initKlaviyoEmbedGuard();
}
